import "../chunk-3W5G4CYI.js";
function isConstructor(f) {
  return typeof f === "function";
}
export {
  isConstructor
};
//# sourceMappingURL=isConstructor.js.map